import request from '@/utils/request'

  
export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/OrderSalesman/Create',
    method: 'post',
    data,
  })
}

export function fetchList(data) {
  console.log('List', data)

  return request({
    url: '/OrderSalesman/List',
    method: 'post',
    data,
  })
}


export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/OrderSalesman/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/OrderSalesman/Delete',
    method: 'delete',
    data,
  })
}
  

 
export function FetchSalesListForReport(data) {
 
  return request({
    url: '/OrderSalesman/SalesListForReport',
    method: 'post',
    data,
  })
}



